import { cssVar } from '@fabric-app/ui/theme/variables';
import { motion } from 'framer-motion';
import { styled } from 'styled-components';

const DashboardPageWrapper = styled(motion.div).withConfig({
  displayName: "DashboardPageWrapper",
  componentId: "sc-30c087e2-0"
})([
  `display:flex;flex-direction:column;height:100dvh;overflow:hidden;background:`,
  `;`,
  ` `,
  ``
], cssVar["color-bg-primary"], (p) => p.alignItems && `align-items: ${p.alignItems};`, (p) => p.justifyContent && `justify-content: ${p.justifyContent};`);

export { DashboardPageWrapper };
//# sourceMappingURL=DashboardPageWrapper.js.map
